export const PAY_CONFIG_SET_UP_REQUEST_FORM =
  'https://airtable.com/shrgrUUYpanXEOoor?prefill_RequestStatus-All=Backlog';

export const SLACK_PAY_CHANNEL = 'https://scaleapi.slack.com/archives/C02T81FBHSL';
